import { createSlice } from '@reduxjs/toolkit'
// import { ethers } from 'ethers';
// import { abi, contractAddress } from '../../constants/abi';
// import { usdtAbi, usdtContractAddress } from '../../constants/usdtAbi';

const initialState = {
    friday: false,
    tuesday: false,
    both: false,
    fridayTime:0,
    tuesdayTime:0,
    
}

export const lotteryDaySlice = createSlice({
    name: 'lotteryDay',
    initialState,
    reducers: {
        addLotteryFriday: (state, action) => {
            // console.log('connect', action.payload);å
            return {
                ...state,
                friday: true,
                fridayTime:action.payload.time
            }
        },
        addLotteryTuesday: (state,action) => {
            return { ...state,tuesday: true ,tuesdayTime:action.payload.time }
        },
        addLotteryBoth: (state) => {
            return { ...state,both: true }
        }
    },
})

// Action creators are generated for each case reducer function
export const { addLotteryFriday, addLotteryTuesday, addLotteryBoth } = lotteryDaySlice.actions

export default lotteryDaySlice.reducer